import { Menu as BaseMenu } from "@base-ui/react/menu";
import type { MenuItemProps } from "..";
import { useMenuLink } from "../menuLinkContext";
import {
  circleIndicatorClass,
  firstBarClass,
  secondBarClass,
} from "../styles.css";
import {
  subitemContainerClass,
  subitemHeaderClass,
  subitemHeaderRegularClass,
  subitemHeaderSubsubitemClass,
} from "./styles.css";

interface MenuSubitemProps {
  subitem: MenuItemProps;
}

export const MenuSubitem = ({ subitem }: MenuSubitemProps) => {
  const LinkComponent = useMenuLink();
  const hasSubitems = subitem.subitems && subitem.subitems.length > 0;
  const pathToGo = subitem.overridePath
    ? subitem.overridePath
    : subitem.external
      ? "#"
      : subitem.path || "#";

  const hasSecondBar =
    (!subitem.isSubsubitem && hasSubitems) ||
    (subitem.isSubsubitem && !subitem.isLastSubsubitem);

  const handleClick = () => {
    if (subitem.external) {
      window.open(subitem.external, "_blank");
    }
  };

  const subitemClass =
    subitemHeaderClass +
    " " +
    (subitem.isSubsubitem
      ? subitemHeaderSubsubitemClass
      : subitemHeaderRegularClass);

  return (
    <div id={`menu-item-${subitem.id}`} className={subitemContainerClass}>
      <BaseMenu.Item
        render={
          <LinkComponent
            to={pathToGo}
            href={pathToGo}
            className={subitemClass}
          />
        }
        onClick={handleClick}
        closeOnClick={true}
      >
        {subitem.isSubsubitem && <div className={firstBarClass} />}
        {(hasSubitems || subitem.isSubsubitem) && (
          <div className={circleIndicatorClass} />
        )}
        <span>{subitem.text}</span>
        {hasSecondBar && <div className={secondBarClass} />}
      </BaseMenu.Item>
    </div>
  );
};
